import {aiVendorLogos, aiVendorNames, genAIVendorUiName} from './aiImages.consts';
import {
  AIImage,
  GenAiService,
  ImageAnalysisResponse,
  RemoteAIImage,
  RemoteGenAiService,
  RemoteImageAnalysisResponse,
} from './aiImages.types';

function addBase64Prefix(image: string): string {
  return `data:image/png;base64,${image}`;
}

function imageToDefaultMask(image: HTMLCanvasElement): HTMLCanvasElement {
  const mask = document.createElement('canvas');
  mask.width = image.width;
  mask.height = image.height;
  const maskCtx = mask.getContext('2d');
  const imageData = image.getContext('2d').getImageData(0, 0, image.width, image.height);

  for (let i = 0; i < imageData.data.length; i += 4) {
    if (imageData.data[i + 3] < 255) {
      imageData.data[i] = 255;
      imageData.data[i + 1] = 255;
      imageData.data[i + 2] = 255;
    } else {
      imageData.data[i] = 0;
      imageData.data[i + 1] = 0;
      imageData.data[i + 2] = 0;
    }

    imageData.data[i + 3] = 255;
  }

  maskCtx.putImageData(imageData, 0, 0);

  return mask;
}

function toClientAIImage(image: RemoteAIImage): AIImage {
  return {
    url: addBase64Prefix(image.base64Image),
    vendorName: aiVendorNames[image.vendor],
    vendorIconUrl: aiVendorLogos[image.vendor],
  };
}

function toClientGenAiService({action, services}: RemoteGenAiService): GenAiService {
  return {
    action: action,
    services: services.map(({vendorService, description, vendor, serviceUiName}) => ({
      label: `${genAIVendorUiName[vendor]}${serviceUiName ? ` - ${serviceUiName}` : ''}`,
      value: vendorService,
      description: description,
    })),
  };
}

function toRemoteMaskImage(canvas: HTMLCanvasElement) {
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;

  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);

  const imgData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
  const data = imgData.data;

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];

    if (alpha > 0) {
      // Any non-transparent pixel becomes fully opaque white
      data[i] = 255;
      data[i + 1] = 255;
      data[i + 2] = 255;
      data[i + 3] = 255;
    } else {
      // Transparent pixels stay transparent
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 0;
    }
  }

  tempCtx.putImageData(imgData, 0, 0);

  return tempCanvas;
}

// Since ImageAnalysisResponse is now a type alias for RemoteImageAnalysisResponse,
// this function is just a pass-through but keeps the API consistent
function toClientImageAnalysis(response: RemoteImageAnalysisResponse): ImageAnalysisResponse {
  return response;
}

export {
  addBase64Prefix,
  imageToDefaultMask,
  toClientAIImage,
  toClientGenAiService,
  toClientImageAnalysis,
  toRemoteMaskImage,
};
